interface ArrowRightIconProps {
	iconColor?: string;
	width?: string;
	height?: string;
}
const ArrowDownIcon = ({ iconColor = '#343A40', width = '16', height = '16' }: ArrowRightIconProps) => (
	<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12.666 6.00033L8.84788 9.81847C8.37925 10.2871 7.61945 10.2871 7.15082 9.81846L3.33268 6.00033"
			stroke={iconColor}
			strokeWidth="1.2"
			strokeLinecap="round"
		/>
	</svg>
);

export default ArrowDownIcon;
